import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';

import Icon from '@visa/vds-react/icon-styled';
import VisuallyHidden from '@reach/visually-hidden';

import styles from './filter.styles';

const DropdownFilter = ({ children, filterLabel, onFilter }) => {
  const inputKeyDown = (event, isOpen, backButtonId) => {
    if (event.key === 'Tab' && isOpen) {
      event.nativeEvent.preventDefault();

      event.nativeEvent.preventDownshiftDefault = true;
      const backButton = document.getElementById(backButtonId); // eslint-disable-line
      if (backButton) {
        backButton.focus();
      }
    }
  };

  const filterRow = ({ labelProps, inputProps, isOpen, backId }) => {
    const iProps = {
      ...inputProps({
        onBlur: event => {
          event.nativeEvent.preventDownshiftDefault = true;
        },
        onKeyDown: e => {
          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.stopPropagation();
          inputKeyDown(e, isOpen, backId);
        }
      })
    };

    return (
      <div css={styles().wrapper}>
        <label htmlFor={filterLabel} css={styles().label} {...labelProps}>
          <Icon name="search" resolution="low" />
          <VisuallyHidden>{filterLabel}</VisuallyHidden>
        </label>
        <input
          css={styles().input}
          id={`dropdown-filter-search-${shortid.generate()}`}
          tabIndex="0"
          placeholder={filterLabel}
          {...iProps}
        />
      </div>
    );
  };

  filterRow.displayName = 'filterRow';

  filterRow.propTypes = {
    backId: PropTypes.string.isRequired,
    inputProps: PropTypes.objectOf(PropTypes.any).isRequired,
    isOpen: PropTypes.bool.isRequired,
    labelProps: PropTypes.objectOf(PropTypes.any).isRequired
  };

  DropdownFilter.displayName = 'DropdownFilter';

  return children({ filterLabel, onFilter, filterRow });
};

DropdownFilter.displayName = 'DropdownFilter';

DropdownFilter.defaultProps = {
  filterLabel: 'Search'
};

DropdownFilter.propTypes = {
  filterLabel: PropTypes.string,
  onFilter: PropTypes.func.isRequired
};

export default DropdownFilter;
